import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import { saveTask } from "../../../../services/usersService";
import AppForm from "../../../../partials/content/Forms/AppForm";
import TaskFormContent from "./taskFormContent";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { sendTasks } from "../../../../utils/utils";
import store from "../../../../store/store";
function TaskForm({
  task = { ID: 0 },
  journeyID = 0,
  operationCardID = 0,
  salesOrderItemID = 0,
  visitActivity = {
    ID: 0,
    activityID: 0,
  },
  onConfirmSave,
  onCloseDialog,
}) {
  const { auth } = store.getState();
  const { socket } = useGlobalData();
  const { fullName } = auth.user;
  const [taskData, setTaskData] = useState({
    ID: 0,
    statusID: 0,
    visitActivityID: visitActivity.ID,
    salesActivityID: visitActivity.activityID,
    operationCardID,
    salesOrderItemID,
    statusDesc: "",
    title: "",
    fromUserID: 0,
    userID: 0,
    userName: "",
    reviewerUserID: 0,
    reviewer: "",
    description: "",
    deadlineDate: DateTime.now().endOf("day"),
  });

  const taskSchema = yup.object().shape({
    ID: yup.number(),
    title: yup
      .string()
      .required("Task Card Name is required")
      .max(255, "Task Card Name maximum characters is 255"),
    userName: yup.string().required("Assigned To is required"),
    description: yup.string(),
    deadlineDate: yup.date().required("Deadline Date is required"),
    statusID: yup.number().min(1, "Task Status is Required"),
  });
  useEffect(() => {
    if (task && task.ID > 0) {
      setTaskData(task);
    }
  }, [task]);

  return (
    <AppForm
      initialValues={taskData}
      validationSchema={taskSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Task ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              const task = { ...values };
              task.visitActivityID = parseFloat(task.visitActivityID);
              task.salesActivityID = parseFloat(task.salesActivityID);
              task.operationCardID = parseFloat(task.operationCardID);
              task.salesOrderItemID = parseFloat(task.salesOrderItemID);
              saveTask(task).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                sendTasks(socket, fullName, [{ ID: values.userID }]);
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <TaskFormContent journeyID={journeyID} onCloseDialog={onCloseDialog} />
    </AppForm>
  );
}

export default TaskForm;
